export { default as FormValidator } from './FormValidator';

// Form schemas
import { CURRENT_AWARD_YEAR } from '../constants/evaluation';
import smddSchema, { getSmddFormSchema } from './smddFormSchema';

export const formSchemas = {
  smdd: smddSchema,
};

export const getFormSchema = (
  schemaName: string = 'smdd',
  year: number = CURRENT_AWARD_YEAR
): any => {
  if (schemaName === 'smdd') {
    return getSmddFormSchema(year);
  }
  throw new Error(`Schema '${schemaName}' not found`);
};

export const getAvailableSchemas = (): string[] => smddSchema.categories;

// Transform form data to Strapi format using field mappings
export const transformFormDataForStrapi = (
  formData: Record<string, any>,
  category: string,
  year: number = CURRENT_AWARD_YEAR
): Record<string, any> => {
  const schema = getFormSchema('smdd', year);
  const fieldMapping = schema.fieldMappings[category];

  if (!fieldMapping) {
    throw new Error(`No field mapping found for category: ${category}`);
  }

  const transformedData: Record<string, any> = {};

  // Add the category to the transformed data
  transformedData.category = category;

  // Add mandatory award_material field for Strapi
  transformedData.award_material = formData.award_material || 'default';

  // Transform each field according to the mapping
  Object.entries(formData).forEach(([formFieldName, value]) => {
    const strapiFieldName = fieldMapping[formFieldName];
    if (strapiFieldName) {
      transformedData[strapiFieldName] = value;
    } else if (
      ['award_material', 'video_url', 'competition_stage'].includes(
        formFieldName
      )
    ) {
      transformedData[formFieldName] = value;
    }
  });

  return transformedData;
};
